import indexMixin from "../mixins/index";
const typeObj = {
  text: "div",
  // 普通文字
  paragraph: "p",
  // 段落
  h1: "h1",
  //标题
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6"
};
export default {
  name: "res-text",
  mixins: [indexMixin],

  data() {
    return {// 类型：标题1-6、普通文字、段落，
      // 所有类型： text，paragraph，h1-h6, html
    };
  },

  components: {
    TextType: {
      name: "TextType",

      render(h) {
        return h(typeObj[this.textType], this.textContent);
      },

      props: {
        textType: {
          type: String,
          default: "text"
        },
        textContent: {
          type: String,
          default: ""
        }
      }
    }
  },
  props: {
    textContent: {
      type: String,
      default: ""
    },
    //非禁用
    textType: {
      type: String,
      default: "text"
    }
  }
};